import { AxiosInstance } from "axios"
import { CompaniesMerchantItem, CompaniesOrderItem } from "./posTypes"

export enum CompanyReportsAccountingQuery {
    MERCHANTS_FOR_COMPANY = "merchants-for-company",
    POS_ORDERS_FOR_COMPANY = "pos-orders-for-company",
}

export type CompaniesOrdersParams = Readonly<{
    companyId: number
    orderId?: string
    startDate?: string
    endDate?: string
    merchantId?: string
    merchantIds?: string
    customerId?: string
    userGroupId?: string
    email?: string
    paymentMethods?: string
    creditCardLast4?: string
    shopIds?: string
}>

export type CompaniesOrdersResponse = Readonly<{
    orders: CompaniesOrderItem[]
}>

export type CompaniesMerchantResponse = Readonly<{
    merchants: CompaniesMerchantItem[]
}>

export async function fetchCompaniesAccountingPosOrders(
    { companyId, ...rest }: CompaniesOrdersParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<CompaniesOrdersResponse> {
    const url = `/companies/${companyId}/accounting/pos/orders`
    const { data } = await axios.get(url, {
        params: rest,
        signal,
    })

    return data
}

export async function fetchCompaniesMerchants(
    { companyId }: { companyId: number },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<CompaniesMerchantResponse> {
    const url = `/companies/${companyId}/merchants`
    const { data } = await axios.get(url, {
        signal,
    })

    return data
}
